<template>
    <div class="exam-result-management">
        <h3> 계정관리 > 감사 로그 및 활동 기록</h3>
        <!-- 검색/필터 영역 -->
        <div class="search-controls">
            <div class="search-row">
                <input type="date" v-model="startDate" class="date-input" ref="startDateInput" @click.stop/>
                <span>~</span>
                <input type="date" v-model="endDate" class="date-input" />
            </div>
            <div class="search-button-row">
                <button @click="search()" class="search-btn">검색</button>
            </div>
        </div>

        <!-- 목록 정렬 드롭다운 -->
        <div class="search-row">
            <div class="list-sort">
                <select v-model="sortOption">
                    <option value="list">목록 정렬</option>
                    <option value="recently">접속 시간</option>
                    <option value="userId">아이디</option>
                    <option value="ipAddress">IP</option>
                    <option value="functionType">기능 유형</option>
                    <option value="loginSuccess">로그인 성공 유무</option>
                </select>
            </div>
            <div class="search-button-row">
                <button @click="print()" class="search-btn">출력</button>
            </div>
        </div>

        <!-- 결과 목록 테이블 -->
        <table class="result-table">
            <thead>
            <tr>
                <th>no</th>
                <th>아이디</th>
                <th>IP 주소</th>
                <th>접속 시간</th>
                <th>기능 유형</th>
                <th>로그인 성공 유무</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(row, idx) in isPrinting ? accountList : pagedAccountList" :key="idx">
                <td>{{ idx + 1 }}</td>
                <td>{{ row.user_id }}</td>
                <td>{{ row.loginip }}</td>  <!-- 오타 수정 -->
                <td>{{ formatDate(row.exam_date) }}</td> <!-- 날짜 포맷팅 함수 적용 추천 -->
                <td>{{ row.exam_type }}</td>
                <td :class="{'text-fail': !row.success}">
                    {{ row.success ? '성공' : '실패' }}
                </td>
            </tr>
            </tbody>
        </table>

        <pagination
            :total-items="totalCount"
            :page-size="pageSize"
            v-model="currentPage"
            @page-change="onPageChange"
        />
    </div>
</template>

<script>
import api, {urls} from '@/api'
import Pagination from "@/components/common/Pagination.vue";

export default {
    name: "ExamResultManagement",
    components: {Pagination},
    data() {
        return {
            startDate: "",
            endDate: "",
            sortOption: "list",
            accountList: [],

            currentPage: 1,       // 현재 페이지 번호
            pageSize: 10,         // 한 페이지에 보여줄 개수 (필요에 따라 변경 가능)
            totalPages: 1,        // 총 페이지 수 (백엔드에서 받아옴)
            totalCount: 0,        // 총 데이터 개수 (옵션, 백엔드에서 받아옴)
            isLoading: false,
            isPrinting: false,
        };
    },
    computed: {
        // 현재 페이지에 보여줄 데이터만 자바스크립트에서 슬라이싱
        pagedAccountList() {
            const start = (this.currentPage - 1) * this.pageSize;
            const end = start + this.pageSize;
            return this.accountList.slice(start, end);
        },
    },
    methods: {
        onPageChange(page) {
            this.currentPage = page;   // 현재 페이지 갱신
        },
        search(page = 1) {
            const params = {
                startDate: this.startDate,
                endDate: this.endDate,
            };

            api.post(urls.account.activityLog, params)
                .then(res => {
                    this.accountList = res.data.list || [];
                    this.totalCount = res.data.totalCount || this.accountList.length;
                    this.totalPages = Math.ceil(this.totalCount / this.pageSize);
                    this.currentPage = page;
                })
                .catch(err => {
                    alert('로그 및 활동기록 목록 조회 실패');
                    this.totalCount = 0;
                    this.totalPages = 1;
                    console.error(err);
                });
        },

        formatDate(dateStr) {
            if (!dateStr) return "";
            const date = new Date(dateStr);
            return date.toLocaleString();  // 예: 2025-07-30 14:36:44 형식
        },
        print() {
            this.isPrinting = true;
            this.$nextTick(() => {
                window.print();
                this.isPrinting = false;
            });
        },
        sortData() {
            if (!this.accountList || this.accountList.length === 0) return;

            const option = this.sortOption;

            this.accountList.sort((a, b) => {
                switch(option) {
                    case 'recently':
                        return new Date(b.exam_date) - new Date(a.exam_date);
                    case 'userId':
                        return a.user_id.localeCompare(b.user_id);
                    case 'ipAddress':
                        return a.loginip.localeCompare(b.loginip);
                    case 'functionType':
                        return a.exam_type.localeCompare(b.exam_type);
                    case 'loginSuccess':
                        // 예: success가 boolean true/false일 경우
                        return (a.success === b.success) ? 0 : (a.success ? -1 : 1);
                    default:
                        return 0;
                }
            });
        },



    },
    mounted() {
        this.search();
    },
    watch: {
        sortOption(newVal, oldVal) {
            this.sortData();
        }
    }
};
</script>